<template>
    <div id="grid-lines" class="grid-lines-anm">
        <div class="col1"></div>
        <div class="col2"></div>
        <div class="col3"></div>
        <div class="col4"></div>
        <div class="col5"></div>
        <div class="col6"></div>
    </div>
</template>

<script>
    export default {
        name: "GridLines"
    }
</script>

<style scoped>
    #grid-lines {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        width: 100%;
        height: 100vh;
        position: fixed;
        z-index: -1;
        margin-top: 100vh;
    }

    .col1, .col2, .col3, .col4, .col5, .col6 {
        border-right: 1px solid rgba(220, 220, 220, 1);
    }

    .col1 {
        grid-column: 1 / 2;
    }

    .col2 {
        grid-column: 2 / 3;
    }

    .col3 {
        grid-column: 3 / 4;
    }

    .col4 {
        grid-column: 4 / 5;
    }

    .col5 {
        grid-column: 5 / 6;
    }

    .col6 {
        grid-column: 6 / 7;
    }

    .grid-lines-anm {
        animation: slide-in-from-bot 1.2s 0.2s ease forwards;
    }

    @keyframes slide-in-from-bot {
        from {
            margin-top: 100vh;
        }
        to {
            margin-top: 0;
        }
    }

    /*** SCREENS ***/

    /* Mobile: Portrait and Landscape */
    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 600px)
    and (-webkit-min-device-pixel-ratio: 2) {

        #grid-lines {
            display: none;
        }
    }

</style>
